"use client"

import Image from "next/image"
import Link from "next/link"
import React from "react"
import FollowOnGoogleButton from "@/app/components/auctor/page/FollowOnGoogleButton"
import {IUser} from "@/app/models/wp"
import {REDACTION_USER_ID} from "@/app/constants/wp"
import logoMini from '@/public/images/RM_logo_V2_mini.svg'

export interface IProductExpert {
    expert: {
        name: string
        img: string
    }
    text: string
}

export interface IDisplayDate {
    label: string
    dateTime: string
}

interface IPageAuthorProps {
    author: IUser
    modifiedAt?: IDisplayDate
    readingTimeMinutes?: number
    productExpert?: IProductExpert
    displayAuthor?: boolean
    reviewer?: IUser
    commentsNumber?: number
}

export default function PageAuthor({
                                       author,
                                       modifiedAt,
                                       readingTimeMinutes = 2,
                                       productExpert,
                                       reviewer,
                                       commentsNumber = 0,
                                   }: IPageAuthorProps) {
    const authorImg = `/assets/avatars/editors/${author.authorPageImg}.png`
    const userName = `${author.firstName} ${author.lastName}`
    const reviewerName = `${reviewer?.firstName} ${reviewer?.lastName}`

    return (
        <div className="py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3 w-fit md:w-full z-20">
            <div className="flex flex-col">
                <div className="flex gap-3 pr-5 rounded-full bg-rm-blue">
                    <div className="relative flex items-center">
                        {author.userId === REDACTION_USER_ID
                            ? <div className="relative w-[45px] h-[45px] p-[5px] rounded-2xl overflow-hidden shrink-0 bg-white">
                                <Image
                                    src={logoMini}
                                    alt={userName}
                                    width={35}
                                    height={35}
                                    sizes="30px"
                                    className="object-cover"
                                    onError={(e) => {
                                        (e.target as HTMLImageElement).style.display = "none"
                                    }}
                                />
                            </div>
                            : <div className="relative w-[45px] h-[45px] rounded-2xl overflow-hidden shrink-0">
                                <Image
                                    src={authorImg}
                                    alt={userName}
                                    fill
                                    sizes="40px"
                                    className="object-cover"
                                    onError={(e) => {
                                        (e.target as HTMLImageElement).style.display = "none"
                                    }}
                                />
                            </div>}

                    </div>

                    <div className="flex flex-col leading-tight text-white justify-center">
                        <Link className="font-bold text-rm-14 w-fit" href={author.authorPageUrl} id="author" rel="author">
                            {userName}
                        </Link>
                        <span className="text-rm-12 ">{author.jobTitle ?? "Expert"}</span>
                    </div>
                </div>

                <div className="flex flex-wrap gap-x-2 gap-y-1 text-[12px]">
                    {modifiedAt &&
                        <div className="bg-white py-0.5 px-2 rounded-full">
                            Mis à jour le <time dateTime={modifiedAt.dateTime}>{modifiedAt.label}</time>
                        </div>
                    }

                    {reviewer &&
                        <div className="bg-white py-0.5 px-2 rounded-full">
                            Relu par {reviewerName}
                        </div>
                    }
                </div>
            </div>

            <FollowOnGoogleButton />
        </div>
    )
}
